<script setup lang="ts">
import apiClient from '@src/api/api-client.ts';
import { closeLoader, openLoader } from '@utils/loader-util.ts';
import { ref } from 'vue';
import { TransferRequestLinePickDocument } from '@src/transfer-request/interfaces/transfer-request-line-pick-document.ts';
import VerticalAlignChildrenWrapper from '@components/layout-wrapper/vertical-align-children-wrapper.vue';
import HorizontalAlignChildrenWrapper from '@components/layout-wrapper/horizontal-align-children-wrapper.vue';
import dateTimeUtil from '@utils/date-time-util.ts';
import ProductImage from '@src/product/components/product-image.vue';
import Text from '@components/text.vue';
import Card from '@components/card.vue';

const pickedLines = ref<Array<TransferRequestLinePickDocument>>([]);
async function loadPickedLines() {
    openLoader();
    pickedLines.value = (await apiClient.get('/be/transfer-request/pick/picked-lines')).data;
    closeLoader();
}

loadPickedLines();

defineExpose({ loadPickedLines });
</script>

<template>
    <VerticalAlignChildrenWrapper gap-top="2" avoid-outer-gap separator>
        <HorizontalAlignChildrenWrapper v-for="pickedLine in pickedLines" :key="pickedLine.id" center-children gap="3">
            <ProductImage size="xxs" :border="false" :product="pickedLine.product"/>
            <VerticalAlignChildrenWrapper>
                <Text bold gap="1">{{ pickedLine.product.name }}</Text>
                <Text gap="1">Gepickt: {{ dateTimeUtil.formatDatetimeToView(pickedLine.timestamp) }}</Text>
                <Text v-if="pickedLine.product.serialNumberRequired" gap="1">Seriennummer: {{ pickedLine.serial }}</Text>
                <Text v-else gap="1">Anzahl: {{ pickedLine.quantity }}</Text>
            </VerticalAlignChildrenWrapper>
        </HorizontalAlignChildrenWrapper>
        <Card v-if="pickedLines.length === 0" card-color="blue">Keine Einträge</Card>
    </VerticalAlignChildrenWrapper>
</template>
